export default {
  startingLineups: {
    title: "Starting Lineups",
    labels: {
      confirmed: "CONFIRMED",
      expected: "EXPECTED",
      tbd: "TBD",
      noLineupAvailable: "No lineup available",
    },
    empty: {
      title: "No lineups available",
    },
  },
};